var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import times from 'lodash/times';
import { Fragment, memo, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StatusPermission } from '../../../../enum';
import { useUserPermissionsAPI } from '../../../app/selectors';
import { Autocomplete, FormField, Table, TableBody, TableCell, TableContainer, TableRow } from '../../../common';
import { ExpandableRowLabel, TABLE_HIERARCHY_INDENTS } from '../../../common/tableHierarchy';
import { OTHER_CURRENCY_ID, currencyAutocompleteListboxProps, useFormlessContext, useRollupAvailableCurrencies, withCurrentCurrencyOption } from '../../../hooks';
import { AddCustomCurrencyDialog } from '../../../orgConfigWizard/financials/AddCustomCurrencyDialog';
import { WizardContext } from '../../context';
import { StyledCountryRow, StyledLocationTypeRow } from '../../locationTable';
import { StyledSiteRow } from '../../locationTable/styles';
import { useEffectiveCapacityPermission, useEffectiveGroupedLocations, useEffectiveLocationIndexMap, useEffectivePlanPermission, useEffectiveQueueLocations, useIsPlanLocked, usePlanAPI, usePlanFxRatesAPI, useSavePlanFxRatesAPI } from '../../selectors';
import { useRoleDeleteState } from '../selectors';
import { RoleRow } from './roleRole';
import { RoleTableHeader } from './roleTableHeader';
var isAgentRole = function (role) {
  return role === 'Agent';
};
var isVisibleRole = function (role, disableFinancial) {
  return !!role && !(disableFinancial && isAgentRole(role.role));
};
var LocationSiteGroup = function (_a) {
  var _b, _c, _d;
  var location = _a.location,
    emptyCols = _a.emptyCols,
    disableFinancial = _a.disableFinancial,
    disableSupportStaff = _a.disableSupportStaff,
    isReview = _a.isReview,
    disabled = _a.disabled,
    requestDelete = _a.requestDelete,
    rolesByLocation = _a.rolesByLocation,
    currencyCodeMap = _a.currencyCodeMap,
    locIndexMap = _a.locIndexMap,
    currencyOptions = _a.currencyOptions,
    isCurrencyUnsupported = _a.isCurrencyUnsupported,
    onSelectOtherCurrency = _a.onSelectOtherCurrency;
  var financialPermission = useUserPermissionsAPI().financialPermission;
  var effectiveFinancialPermission = useEffectivePlanPermission(financialPermission);
  var isPlanLocked = useIsPlanLocked();
  var disableEditFinancial = effectiveFinancialPermission !== StatusPermission.Edit || isPlanLocked;
  var _e = useState(false),
    closed = _e[0],
    setClosed = _e[1];
  var locationRoleIndexes = (_b = rolesByLocation.get(location.id)) !== null && _b !== void 0 ? _b : [];
  var locIdx = locIndexMap.get(location.id);
  var hasVisibleRoles = locationRoleIndexes.some(function (role) {
    return isVisibleRole(role, disableFinancial);
  });
  var locationCurrency = (_c = currencyCodeMap.get(location.id)) !== null && _c !== void 0 ? _c : location.currencyCode;
  var locationCurrencyOptions = withCurrentCurrencyOption(currencyOptions, locationCurrency);
  return _jsxs(Fragment, {
    children: [_jsxs(StyledSiteRow, {
      children: [_jsx(TableCell, __assign({
        component: "th",
        align: "left",
        padding: "none",
        sx: {
          pl: TABLE_HIERARCHY_INDENTS[3]
        }
      }, {
        children: _jsxs(Box, __assign({
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%"
        }, {
          children: [_jsx(Box, __assign({
            sx: {
              flex: 1
            },
            "data-testid": hasVisibleRoles ? 'support-staff-location-toggle-icon' : undefined
          }, {
            children: _jsx(ExpandableRowLabel, __assign({
              expanded: !closed,
              onToggle: hasVisibleRoles ? function () {
                return setClosed(function (p) {
                  return !p;
                });
              } : undefined,
              bold: true
            }, {
              children: (_d = location.planLocation) === null || _d === void 0 ? void 0 : _d.locationName
            }))
          })), !disableFinancial && _jsx(Box, __assign({
            sx: {
              width: 120
            }
          }, {
            children: _jsx(FormField, __assign({
              disableHelperText: true,
              name: "queueLocations.".concat(locIdx, ".currencyCode"),
              defaultValue: "USD"
            }, {
              children: _jsx(Autocomplete, {
                disabled: disabled || disableEditFinancial,
                options: locationCurrencyOptions,
                getOptionLabel: function (o) {
                  return o.id === OTHER_CURRENCY_ID ? o.name : o.id;
                },
                getOptionValue: function (o) {
                  return o.id;
                },
                isOptionEqualToValue: function (o, v) {
                  var _a;
                  return o.id === ((_a = v === null || v === void 0 ? void 0 : v.id) !== null && _a !== void 0 ? _a : v);
                },
                ListboxProps: currencyAutocompleteListboxProps,
                size: "small",
                error: isCurrencyUnsupported === null || isCurrencyUnsupported === void 0 ? void 0 : isCurrencyUnsupported(locationCurrency),
                onChange: function (v) {
                  if (v === OTHER_CURRENCY_ID) {
                    onSelectOtherCurrency === null || onSelectOtherCurrency === void 0 ? void 0 : onSelectOtherCurrency(locIdx);
                    return false;
                  }
                }
              })
            }))
          }))]
        }))
      })), times(emptyCols, function (i) {
        return _jsx(TableCell, {}, i);
      })]
    }), !closed && locationRoleIndexes.map(function (role, roleIdx) {
      var _a;
      if (!isVisibleRole(role, disableFinancial)) return null;
      var isAgent = isAgentRole(role.role);
      return _jsx(RoleRow, {
        formPath: "queueLocations.".concat(locIdx, ".roles.").concat(roleIdx),
        item: role,
        disabled: disabled,
        isAgent: isAgent,
        disableFinancial: disableFinancial,
        disableSupportStaff: disableSupportStaff,
        isReview: isReview,
        currencyCode: (_a = currencyCodeMap.get(location.id)) !== null && _a !== void 0 ? _a : location.currencyCode,
        indented: true,
        onDelete: function () {
          return requestDelete(role.id);
        }
      }, "".concat(role.role, "-").concat(roleIdx));
    })]
  });
};
var CountryGroup = function (_a) {
  var country = _a.country,
    countryLocations = _a.countryLocations,
    emptyCols = _a.emptyCols,
    props = __rest(_a, ["country", "countryLocations", "emptyCols"]);
  var _b = useState(false),
    closed = _b[0],
    setClosed = _b[1];
  return _jsxs(Fragment, {
    children: [_jsxs(StyledCountryRow, {
      children: [_jsx(TableCell, __assign({
        component: "th",
        align: "left",
        padding: "none",
        sx: {
          pl: TABLE_HIERARCHY_INDENTS[2],
          py: 2
        }
      }, {
        children: _jsx(ExpandableRowLabel, __assign({
          expanded: !closed,
          onToggle: function () {
            return setClosed(function (p) {
              return !p;
            });
          },
          bold: true
        }, {
          children: country
        }))
      })), times(emptyCols, function (i) {
        return _jsx(TableCell, {}, i);
      })]
    }), !closed && countryLocations.map(function (location) {
      return _jsx(LocationSiteGroup, __assign({
        location: location,
        emptyCols: emptyCols
      }, props), location.id);
    })]
  });
};
var LocationTypeGroup = function (_a) {
  var locationType = _a.locationType,
    countries = _a.countries,
    emptyCols = _a.emptyCols,
    props = __rest(_a, ["locationType", "countries", "emptyCols"]);
  var t = useTranslation('wizard').t;
  var _b = useState(false),
    closed = _b[0],
    setClosed = _b[1];
  var locationTypeKey = locationType;
  return _jsxs(Fragment, {
    children: [_jsxs(StyledLocationTypeRow, {
      children: [_jsx(TableCell, __assign({
        component: "th",
        align: "left",
        padding: "none",
        sx: {
          pl: TABLE_HIERARCHY_INDENTS[1],
          py: 2
        }
      }, {
        children: _jsx(ExpandableRowLabel, __assign({
          expanded: !closed,
          onToggle: function () {
            return setClosed(function (p) {
              return !p;
            });
          },
          bold: true
        }, {
          children: t("message.".concat(locationTypeKey))
        }))
      })), times(emptyCols, function (i) {
        return _jsx(TableCell, {}, i);
      })]
    }), !closed && Object.entries(countries).map(function (_a) {
      var country = _a[0],
        countryLocations = _a[1];
      return _jsx(CountryGroup, __assign({
        country: country,
        countryLocations: countryLocations,
        emptyCols: emptyCols
      }, props), country);
    })]
  });
};
var LocationGroupedBody = function (_a) {
  var _b, _c, _d, _e;
  var disableFinancial = _a.disableFinancial,
    disableSupportStaff = _a.disableSupportStaff,
    isReview = _a.isReview,
    disabled = _a.disabled,
    requestDelete = _a.requestDelete;
  var tOrgConfig = useTranslation('orgConfig', {
    keyPrefix: 'financials'
  }).t;
  var locations = useEffectiveQueueLocations();
  var groupedLocations = useEffectiveGroupedLocations();
  var locIndexMap = useEffectiveLocationIndexMap();
  var _f = (_b = useFormlessContext()) !== null && _b !== void 0 ? _b : {},
    control = _f.control,
    setValue = _f.setValue;
  var planData = usePlanAPI()[0];
  var rollupCurrency = ((_d = (_c = planData.data) === null || _c === void 0 ? void 0 : _c.currency) !== null && _d !== void 0 ? _d : 'USD').toUpperCase();
  var _g = usePlanFxRatesAPI(),
    fxRatesData = _g[0],
    fetchFxRates = _g[1];
  var _h = useSavePlanFxRatesAPI(),
    saveFxRates = _h[1];
  useEffect(function () {
    fetchFxRates();
  }, [fetchFxRates]);
  var knownRateCodes = useMemo(function () {
    var _a, _b;
    return ((_b = (_a = fxRatesData.data) === null || _a === void 0 ? void 0 : _a.rates) !== null && _b !== void 0 ? _b : []).map(function (r) {
      return r.currencyCode;
    });
  }, [(_e = fxRatesData.data) === null || _e === void 0 ? void 0 : _e.rates]);
  // A just-added custom code isn't in knownRateCodes until the save round-trips through
  // findPlanFxRates (which only reports currencies a saved queue location actually uses) -- keep
  // it supported locally in the meantime, same pattern as the org config financials step.
  var _j = useState([]),
    pendingCustomCodes = _j[0],
    setPendingCustomCodes = _j[1];
  var supportedCodes = useMemo(function () {
    return Array.from(new Set(__spreadArray(__spreadArray([], knownRateCodes, true), pendingCustomCodes, true)));
  }, [knownRateCodes, pendingCustomCodes]);
  var _k = useRollupAvailableCurrencies(rollupCurrency, {
      extraSupportedCodes: supportedCodes
    }),
    baseCurrencyOptions = _k.options,
    isSupported = _k.isSupported;
  var otherOptionLabel = String(tOrgConfig('location.otherCurrency', {
    defaultValue: 'Other...'
  }));
  var currencyOptions = useMemo(function () {
    return __spreadArray(__spreadArray([], baseCurrencyOptions, true), [{
      id: OTHER_CURRENCY_ID,
      name: otherOptionLabel,
      symbol: ''
    }], false);
  }, [baseCurrencyOptions, otherOptionLabel]);
  var _l = useState(undefined),
    customCurrencyLocIdx = _l[0],
    setCustomCurrencyLocIdx = _l[1];
  var handleAddCustomCurrency = useCallback(function (_a) {
    var currencyCode = _a.currencyCode,
      corporateOverrideRate = _a.corporateOverrideRate;
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_b) {
        if (customCurrencyLocIdx == null) return [2 /*return*/];
        setPendingCustomCodes(function (prev) {
          return prev.includes(currencyCode) ? prev : __spreadArray(__spreadArray([], prev, true), [currencyCode], false);
        });
        saveFxRates({
          rates: [{
            currencyCode: currencyCode,
            corporateOverrideRate: corporateOverrideRate
          }]
        });
        fetchFxRates();
        setValue === null || setValue === void 0 ? void 0 : setValue("queueLocations.".concat(customCurrencyLocIdx, ".currencyCode"), currencyCode, {
          shouldDirty: true
        });
        return [2 /*return*/];
      });
    });
  }, [customCurrencyLocIdx, saveFxRates, fetchFxRates, setValue]);
  var rolesByLocation = useMemo(function () {
    return new Map(locations.map(function (loc) {
      var _a;
      return [loc.id, (_a = loc.roles) !== null && _a !== void 0 ? _a : []];
    }));
  }, [locations]);
  // Watch live currency codes so per-location currency updates are reflected
  var watchedQueueLocations = useWatch({
    control: control,
    name: 'queueLocations'
  });
  var currencyCodeMap = useMemo(function () {
    var map = new Map();
    for (var _i = 0, _a = watchedQueueLocations !== null && watchedQueueLocations !== void 0 ? watchedQueueLocations : []; _i < _a.length; _i++) {
      var ql = _a[_i];
      if (ql === null || ql === void 0 ? void 0 : ql.id) {
        map.set(ql.id, ql.currencyCode);
      }
    }
    return map;
  }, [watchedQueueLocations]);
  // Number of filler cells to span after the first "label" cell in group rows
  var emptyCols = function () {
    if (disableFinancial) {
      if (isReview) {
        return 3;
      }
      return 4;
    }
    if (disableSupportStaff) {
      return 3;
    }
    return 6;
  }();
  var sharedProps = {
    disableFinancial: disableFinancial,
    disableSupportStaff: disableSupportStaff,
    isReview: isReview,
    disabled: disabled,
    requestDelete: requestDelete,
    rolesByLocation: rolesByLocation,
    currencyCodeMap: currencyCodeMap,
    locIndexMap: locIndexMap,
    currencyOptions: currencyOptions,
    isCurrencyUnsupported: function (code) {
      return Boolean(code && !isSupported(code));
    },
    onSelectOtherCurrency: setCustomCurrencyLocIdx,
    emptyCols: emptyCols
  };
  return _jsxs(_Fragment, {
    children: [Object.entries(groupedLocations).map(function (_a) {
      var locationType = _a[0],
        countries = _a[1];
      return _jsx(LocationTypeGroup, __assign({
        locationType: locationType,
        countries: countries
      }, sharedProps), locationType);
    }), _jsx(AddCustomCurrencyDialog, {
      open: customCurrencyLocIdx != null,
      rollupCurrency: rollupCurrency,
      existingCodes: currencyOptions.map(function (o) {
        return o.id;
      }),
      onClose: function () {
        return setCustomCurrencyLocIdx(undefined);
      },
      onSave: handleAddCustomCurrency
    })]
  });
};
var FlatBody = function (_a) {
  var disableFinancial = _a.disableFinancial,
    disableSupportStaff = _a.disableSupportStaff,
    isReview = _a.isReview,
    disabled = _a.disabled,
    currency = _a.currency,
    roles = _a.roles,
    requestDelete = _a.requestDelete;
  var t = useTranslation(['wizard', 'translation']).t;
  var hasVisibleRoles = useMemo(function () {
    return roles === null || roles === void 0 ? void 0 : roles.some(function (item) {
      var isAgent = isAgentRole(item.role);
      return !(disableFinancial && isAgent);
    });
  }, [roles, disableFinancial]);
  var colSpan = useMemo(function () {
    return 1 + (disableSupportStaff ? 0 : 3) + (disableFinancial ? 0 : 3) + (!disableSupportStaff && !isReview ? 1 : 0);
  }, [disableSupportStaff, disableFinancial, isReview]);
  if (!hasVisibleRoles) {
    return _jsx(TableRow, {
      children: _jsx(TableCell, __assign({
        colSpan: colSpan,
        align: "center"
      }, {
        children: _jsx(Stack, __assign({
          height: '6rem',
          alignItems: "center",
          justifyContent: "center"
        }, {
          children: _jsxs(Typography, __assign({
            variant: "body2"
          }, {
            children: [" ", t('translation:noDataIndication')]
          }))
        }))
      }))
    });
  }
  return _jsx(_Fragment, {
    children: roles === null || roles === void 0 ? void 0 : roles.map(function (item, rowIdx) {
      var isAgent = isAgentRole(item.role);
      if (disableFinancial && isAgent) return null;
      return _jsx(RoleRow, {
        formPath: "roles.".concat(rowIdx),
        item: item,
        disabled: disabled,
        isAgent: isAgent,
        disableFinancial: disableFinancial,
        disableSupportStaff: disableSupportStaff,
        isReview: isReview,
        currencyCode: currency,
        indented: false,
        onDelete: function () {
          return requestDelete(item.id);
        }
      }, "".concat(item.role, "-").concat(rowIdx));
    })
  });
};
export var SupportStaffTable = memo(function (_a) {
  var _b;
  var _c = _a.disableFinancial,
    disableFinancial = _c === void 0 ? false : _c,
    _d = _a.disableSupportStaff,
    disableSupportStaff = _d === void 0 ? false : _d,
    _e = _a.isReview,
    isReview = _e === void 0 ? false : _e;
  var locations = useEffectiveQueueLocations();
  var hasLocations = !!locations.length;
  var wizardContext = useContext(WizardContext);
  var isDirty = useFormContext().formState.isDirty;
  var handleSave = wizardContext === null || wizardContext === void 0 ? void 0 : wizardContext.handleSave;
  var capacityPermission = useEffectiveCapacityPermission();
  var isPlanLocked = useIsPlanLocked();
  var disabled = capacityPermission !== StatusPermission.Edit || isPlanLocked;
  var control = ((_b = useFormlessContext()) !== null && _b !== void 0 ? _b : {}).control;
  var currency = useWatch({
    control: control,
    name: 'sourceCurrencyCode'
  });
  var roles = useWatch({
    control: control,
    name: 'roles'
  });
  var _f = useState(),
    selectedRoleId = _f[0],
    setSelectedRoleId = _f[1];
  var requestDelete = useRoleDeleteState(selectedRoleId, setSelectedRoleId).requestDelete;
  var handleDelete = function (id) {
    if (isDirty && handleSave) {
      return handleSave('submit', function () {
        return requestDelete(id);
      })();
    }
    requestDelete(id);
  };
  var sharedProps = {
    disableFinancial: disableFinancial,
    disableSupportStaff: disableSupportStaff,
    isReview: isReview
  };
  return _jsx(TableContainer, __assign({
    topScroll: hasLocations
  }, {
    children: _jsxs(Table, {
      children: [_jsx(RoleTableHeader, __assign({}, sharedProps)), _jsx(TableBody, {
        children: hasLocations ? _jsx(LocationGroupedBody, __assign({}, sharedProps, {
          disabled: disabled,
          requestDelete: handleDelete
        })) : _jsx(FlatBody, __assign({}, sharedProps, {
          disabled: disabled,
          currency: currency,
          roles: roles,
          requestDelete: handleDelete
        }))
      })]
    })
  }));
});